import { defaultApiState } from "@/store/general.types";
import { CitationState } from "./citation.types";

export const citationState: CitationState = {
    getUser: defaultApiState,
}